import InputText from "./Input.Text";

export default InputText;